// SPDX-License-Identifier: AGPL-3.0-or-later

import {handleChannelCreate} from '@app/features/channel/events/ChannelCreate';
import {handleChannelDelete} from '@app/features/channel/events/ChannelDelete';
import {handleChannelUpdate} from '@app/features/channel/events/ChannelUpdate';
import Channels from '@app/features/channel/state/Channels';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import type {VoiceState} from '@app/features/gateway/types/GatewayVoiceTypes';
import ReadStates from '@app/features/read_state/state/ReadStates';
import MediaEngine from '@app/features/voice/engine/MediaEngineFacade';
import type {Channel} from '@app/vendor/schema/domains/channel/ChannelSchemas';

interface PassiveUpdatesPayload {
	guild_id: string;
	channels: Record<string, string>;
	voice_states?: Array<VoiceState>;
	created_channels?: Array<Channel>;
	updated_channels?: Array<Channel>;
	deleted_channel_ids?: Array<string>;
}
export function handlePassiveUpdates(data: PassiveUpdatesPayload, context: GatewayHandlerContext): void {
	const {
		channels,
		voice_states: voiceStates,
		created_channels: createdChannels,
		updated_channels: updatedChannels,
	} = data;
	ReadStates.handlePassiveLastMessageUpdates(channels);
	if (createdChannels?.length) {
		for (const channel of createdChannels) {
			handleChannelCreate(channel, context);
		}
	}
	if (updatedChannels?.length) {
		for (const channel of updatedChannels) {
			handleChannelUpdate(channel, context);
		}
	}
	if (data.deleted_channel_ids?.length) {
		for (const channelId of data.deleted_channel_ids) {
			const existingChannel = Channels.getChannel(channelId);
			if (existingChannel) {
				handleChannelDelete(existingChannel.toJSON(), context);
			}
		}
	}
	if (voiceStates?.length) {
		MediaEngine.handlePassiveVoiceStates(data.guild_id, voiceStates);
	}
}
